import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";
import RolePicker from "../RolePicker";

export default function DonorSupportSection({
  channels,
  roles,
  donorSupport,
  setDonorSupport,
}) {
  const roleIds = donorSupport?.roleIds || {};

  const update = (patch) => {
    setDonorSupport((prev) => ({
      ...prev,
      ...patch,
    }));
  };

  const updateRole = (key, value) => {
    setDonorSupport((prev) => ({
      ...prev,
      roleIds: {
        ...(prev.roleIds || {}),
        [key]: value,
      },
    }));
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Only for Nocturne and the test server. Map Stripe tiers to Discord
        roles and optionally announce new donations in a channel. Roles sync on
        both home servers; announcements post to <b>Nocturne only</b> (not the
        test server unless you set <code>DONOR_ANNOUNCE_TEST_GUILD=1</code> on
        the backend). Pick a channel the bot can see and send messages in.
      </p>

      <label className="input-label">SUPPORTER ROLE</label>
      <RolePicker
        roles={roles}
        value={roleIds.supporter || ""}
        onChange={(v) => updateRole("supporter", v)}
        emptyLabel="None"
        placeholder="Select supporter role…"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        PATRON ROLE
      </label>
      <RolePicker
        roles={roles}
        value={roleIds.patron || ""}
        onChange={(v) => updateRole("patron", v)}
        emptyLabel="None"
        placeholder="Select patron role…"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        BENEFACTOR ROLE
      </label>
      <RolePicker
        roles={roles}
        value={roleIds.benefactor || ""}
        onChange={(v) => updateRole("benefactor", v)}
        emptyLabel="None"
        placeholder="Select benefactor role…"
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Benefactors also keep the Patron role when both are set. Supporter is
        lifetime; Patron/Benefactor roles drop when the subscription ends.
      </p>

      <label className="input-label" style={{ marginTop: "15px" }}>
        DONATION ANNOUNCE CHANNEL
      </label>
      <ChannelPicker
        channels={channels}
        value={donorSupport?.announceChannelId || ""}
        onChange={(v) => update({ announceChannelId: v })}
        emptyLabel="None (no public donation message)"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        DONATION MESSAGE
      </label>
      <textarea
        value={donorSupport?.announceMessage || ""}
        onChange={(e) => update({ announceMessage: e.target.value })}
        className="settings-input large-text"
        rows={4}
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Donations via kamigrove.com (not Discord boosts). Placeholders:{" "}
        {"{user}"} {"{userName}"} {"{tier}"} {"{server}"}
      </p>
    </SettingsSection>
  );
}
